import { profile } from "./_duck"

export const RATINGS_GET_REQUEST: string = profile.defineType("RATINGS_GET_REQUEST")
export const RATINGS_GET_SUCCESS: string = profile.defineType("RATINGS_GET_SUCCESS")
export const RATINGS_GET_FAILURE: string = profile.defineType("RATINGS_GET_FAILURE")
